import { render, staticRenderFns } from "./PapercleanAnagraficaListComponent.vue?vue&type=template&id=30a2f888"
import script from "./PapercleanAnagraficaListComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanAnagraficaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports